import "./AllMembers.css";
import { Button, Modal, Table } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { simplifyTradingVolume } from "../../../../helpers/helper";
import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { updateUser } from "../../../../redux/users/usersSlice";
import { useDispatch, useSelector } from "react-redux";
import cancel from "../../../../assets/images/cancel.svg";
import cross from "../../../../assets/images/cross.svg";
import FloatingDropdownWithArrow from "../../CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow";
import ExactDateSelector from "../../CommonComponents/ExactDateSelector/ExactDateSelector";
import dropdownAngle from "../../../../assets/images/dropdownAngle.svg";
import Form from "react-bootstrap/Form";
import MessageModal from "../MessageModal/MessageModal";
import NewCopyIcon from "../../../../assets/images/NewCopyIcon.svg";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import rightAngle from "../../../../assets/images/rightAnglePath.svg";
import tierAction from "../../../../assets/images/tierAction.svg";
import dayjs from "dayjs";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import vipCheckMark from "../../../../assets/images/vipCheckMark.svg";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import SearchBar from "../../CommonComponents/SearchBar/SearchBar";
import TablePagination from "../../../sharedPages/CommonComponents/NewPagination/NewPagination";
import ConfirmModal from "../../CommonComponents/ConfirmModal/ConfirmModal";

const AllMembers = ({ isNewVipAdded }) => {
  const user = useSelector((value) => value?.user?.user);

  const communityLeaderId = user?.leaderCommunity?._id || "";
  const [participants, setParticipants] = useState(
    user?.leaderCommunity?.participants || []
  );
  const subscriptions = user?.leaderCommunity?.subscription || [];

  let allTradingCapitals = subscriptions
    .filter((tier) => tier.isActive)
    .map((subscription) => subscription.tradingCapital);
    
  const tiers=subscriptions.filter((subscription) =>subscription.isActive ).map((subscription) => [subscription.monthlyfee, subscription.yearlyfee]);
   allTradingCapitals=tiers.flat(1);
  const vipSubscription = subscriptions.filter((subscription) =>
    subscription.name.endsWith("_Vip")
  )[0];
  if (vipSubscription) allTradingCapitals.push("VIP");

  const [editEmailIndex, setEditEmailIndex] = useState(null);
  const [editExpiryDateIndex, setEditExpiryDateIndex] = useState(null);
  const [filteredParticipants, setFilteredParticipants] = useState([
    ...participants,
  ]);
  const [filteredVipMembers, setFilteredVipMembers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isSendMessages, setIsSendMessages] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [selectedDropdownIndex, setSelectedDropdownIndex] = useState(null);
  const [selectedOption, setSelectedOption] = useState("All subscribers");
  const [selectedParticipant, setSelectedParticipant] = useState("");
  const [selectedSubscription, setSelectedSubscription] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [editValidity, setEditValidity] = useState("");
  const [newEndDate, setNewEndDate] = useState(null);
  const [showDeleteModel, setShowDeleteModel] = useState({
    apiObj: null,
    show: false,
  });
  // const [showDropdown, setShowDropdown] = useState(true);
  const [vipMembers, setVipMembers] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [memberStatusOverrides, setMemberStatusOverrides] = useState({});
  const [showStatusConfirmModal, setShowStatusConfirmModal] = useState({ participant: null, show: false });
  const [isDeleting, setIsDeleting] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
  const [dropdownActions, setDropdownActions] = useState([]);
  const [filterMenuFlipUp, setFilterMenuFlipUp] = useState(false);
  const api = useApi();
  const dispatch = useDispatch();
  const deletedParticipantIds = useRef(new Set());
  const expiryDropdownRef = useRef(null);
  const filterButtonRef = useRef(null);
  const filterDropdownRef = useRef(null);
  const filterMenuRef = useRef(null);
  const actionButtonTriggerRefs = useRef(new Map());
  const sharedDropdownRef = useRef(null);
  const allMemberBoxRef = useRef(null);

  const closeDropdownOnOutsideClick = (e) => {
    if (
      expiryDropdownRef.current &&
      !expiryDropdownRef.current.contains(e.target) &&
      !e.target.closest(".dropdownContent") &&
      !isMobile
    ) {
      setEditExpiryDateIndex(null);
      setShowDatePicker(false);
    }

    if (
      filterButtonRef.current &&
      !filterButtonRef.current.contains(e.target) &&
      filterDropdownRef.current &&
      !filterDropdownRef.current.contains(e.target)
    )
      setIsOpen(false);

    const isInsideDropdown = sharedDropdownRef.current?.contains(e.target);
    const isInsideTrigger = Array.from(actionButtonTriggerRefs.current.values()).some(
      (el) => el?.contains(e.target)
    );
    if (!isInsideDropdown && !isInsideTrigger) {
      setSelectedDropdownIndex(null);
    }
  };
  useEffect(() => {
    let cancelled = false;

    const syncCommunityMembers = async () => {
      const nextParticipants = user?.leaderCommunity?.participants || [];

      deletedParticipantIds.current.clear();
      setMemberStatusOverrides({});
      setSelectedOption("All subscribers");
      setSearchQuery("");
      setPage(1);
      setSelectedDropdownIndex(null);
      setEditEmailIndex(null);
      setEditExpiryDateIndex(null);
      setShowDatePicker(false);
      setParticipants(nextParticipants);
      setFilteredParticipants(nextParticipants);

      if (!nextParticipants.length) return;

      const updatedParticipants = await Promise.all(
        nextParticipants.map(async (member) => {
          const response = await api("post", "/stats/getportfolio", {
            userId: member?.user?._id,
          });

          return {
            ...member,
            balance: response?.status ? response?.data?.balance : 0,
          };
        })
      );

      if (cancelled) return;

      setParticipants(updatedParticipants);
      setFilteredParticipants(
        updatedParticipants.filter(
          (p) => !deletedParticipantIds.current.has(p?.user?._id)
        )
      );
    };

    syncCommunityMembers();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [communityLeaderId]);

  const getAllVipMembers = async () => {
    const response = await api("get", "vipMember/allVipMembers");
    setFilteredVipMembers(response?.data?.vipMembers);
    setVipMembers(response?.data?.vipMembers);
  };

  useEffect(() => {
    const data = ["VIP members", "VIP pending", "VIP"].includes(selectedOption)
      ? filteredVipMembers
      : filteredParticipants;

    setTotalPages(Math.ceil(data.length / 10));
  }, [selectedOption, filteredVipMembers, filteredParticipants, user]);

  useEffect(() => {
    if (!user) return;
    const active = participants.filter(
      (p) => !deletedParticipantIds.current.has(p?.user?._id)
    );
    setFilteredParticipants(active);
  }, [user, participants]);
  const handleOptionSelection = (option) => {

    setSearchQuery("");
    if (option === "All subscribers") {
      setFilteredParticipants([...participants]);
    } else if (["VIP members", "VIP"].includes(option)) {
      setFilteredVipMembers([...vipMembers]);
    } else if (option === "VIP pending") {
      setFilteredVipMembers(
        vipMembers.filter((member) =>
          member?.codeValidity === "Specific end date"
            ? !member?.isUsed && new Date(member?.endDate) > new Date()
            : !member?.isUsed
        )
      );
    } else {
      setFilteredParticipants(
        participants.filter((participant) => {
          const subscriptionId =
            participant?.user?.memberCommunities[0].subscription;
          const matchedSubscription = subscriptions.find(
            (subscription) => subscription._id === subscriptionId
          );
          const memberSubscriptionType=participant?.user?.memberCommunities[0].planType;
          // if (matchedSubscription.tradingCapital === option) return true;
          if ((memberSubscriptionType==="monthly" && Number(matchedSubscription?.monthlyfee) === Number(option))||(memberSubscriptionType==="yearly" && Number(matchedSubscription?.yearlyfee) === Number(option))) return true;
         
          return false;
        })
      );
    }

    setIsOpen(false);
    setSelectedOption(option);
  };
  const getParticipantCommunityRecord = (participant) => {
    const memberCommunities = participant?.user?.memberCommunities;
    if (!memberCommunities?.length) return null;

    return (
      memberCommunities.find(
        (community) => community?.community === communityLeaderId
      ) || memberCommunities[0]
    );
  };

  const getMemberTier = (participant) => {
    if (!subscriptions.length) return null;

    const memberCommunity = getParticipantCommunityRecord(participant);
    if (!memberCommunity?.subscription) return null;

    return (
      subscriptions.find((subscription) => {
        if (subscription?._id !== memberCommunity.subscription) return false;

        if (!memberCommunity?.subscribedPlan) return true;

        return (
          subscription?.monthlyPlanId === memberCommunity.subscribedPlan ||
          subscription?.yearlyPlanId === memberCommunity.subscribedPlan
        );
      }) || null
    );
  };

  const getMemberSubscribedPlanDetails = (participant) => {
    const memberCommunity = getParticipantCommunityRecord(participant);
    const tier = getMemberTier(participant);

    if (!memberCommunity || !tier) return null;

    const subscribedPlanId = memberCommunity?.subscribedPlan;
    let planType = memberCommunity?.planType || null;

    if (subscribedPlanId) {
      if (tier?.monthlyPlanId === subscribedPlanId) planType = "monthly";
      else if (tier?.yearlyPlanId === subscribedPlanId) planType = "yearly";
    }

    const normalizedPlanType = planType === "yearly" ? "yearly" : "monthly";
    const planAmount =
      normalizedPlanType === "yearly"
        ? tier?.yearlyfee ?? tier?.monthlyfee
        : tier?.monthlyfee ?? tier?.yearlyfee;

    return {
      tier,
      planType: normalizedPlanType,
      amount: planAmount,
      subscribedPlanId: subscribedPlanId || null,
    };
  };
  
  const getMemberSubscribedTier = (participant) => {
    const tierDetails = getMemberSubscribedPlanDetails(participant);
    const tier = tierDetails?.tier;

    return tier
      ? {
          name: tier?.name,
          tradingCapital: tier?.tradingCapital,
          planType: tierDetails?.planType,
          amount: tierDetails?.amount,
        }
      : null;
  };

  const getMemberTierDisplay = (participant) => {
    const amount = getMemberSubscribedTier(participant)?.amount;
    if (amount == null || amount === "") return "-";
    return `$${amount}`;
  };

  const getSubscription = (participant) =>
    subscriptions.find(
      (subscription) =>
        subscription._id ===
        participant?.user?.memberCommunities?.[0]?.subscription
    );

  const getTradingCapital = (participant) => {
    const subscription = getSubscription(participant);
    const capital = subscription?.tradingCapital;
    if (capital == null || capital === "") return "-";
    return capital === "UNLIMITED" ? capital : `$${capital}`;
  };

  const getEndDate = (endDate) => {
    return dayjs(endDate).format("DD-MM-YYYY");
  };

  const getEffectiveMemberStatus = (participant) => {
    const memberId = participant?.user?._id;
    if (memberStatusOverrides[memberId] !== undefined) {
      return memberStatusOverrides[memberId];
    }
    return participant?.isActive === false ? "inactive" : "active";
  };

  const updateMemberStatus = async (participant) => {
    const memberId = participant?.user?._id;
    const currentStatus = getEffectiveMemberStatus(participant);
    const isCurrentlyInactive = currentStatus === "inactive";
    const newIsActive = isCurrentlyInactive;
    const newStatus = newIsActive ? "active" : "inactive";

    // Optimistic update — reflect change immediately
    setMemberStatusOverrides((prev) => ({ ...prev, [memberId]: newStatus }));

    const response = await api("post", "multiCommunity/updateMemberActiveStatus", {
      memberId,
      communityId: communityLeaderId,
      isActive: newIsActive,
    });

    if (response?.status) {
      const applyIsActive = (list) =>
        list.map((p) => p?.user?._id !== memberId ? p : { ...p, isActive: newIsActive });
      setParticipants((prev) => applyIsActive(prev));
      setFilteredParticipants((prev) => applyIsActive(prev));
      setMemberStatusOverrides((prev) => { const next = { ...prev }; delete next[memberId]; return next; });

      showNotificationToast(
        newIsActive ? "Member activated successfully." : "Member deactivated successfully."
      );
    } else {
      // Revert on failure
      setMemberStatusOverrides((prev) => ({ ...prev, [memberId]: currentStatus }));
      toastify(response?.message || response?.error || "Failed to update member status.", "error");
    }
  };

  const unsubscribeMember = async () => {
    setIsDeleting(true);
    const response = await api("post", "users/unsubscribe", {
      communityId: communityLeaderId,
      leader: true,
      sessionId: selectedSubscription,
      userId: selectedParticipant,
    });

    if (response?.status) {
      deletedParticipantIds.current.add(selectedParticipant);
      // dispatch(updateUser(response?.data?.user)); — skipped: dispatching changes user in Redux which triggers useEffect([user]) and overwrites filteredParticipants with stale data before setParticipants has settled
      setParticipants((prev) => prev.filter((p) => p?.user?._id !== selectedParticipant));
      setFilteredParticipants((prev) => prev.filter((p) => p?.user?._id !== selectedParticipant));
      showNotificationToast("User unsubscribed successfully.");
    } else {
      toastify(response?.error);
    }
    setIsDeleting(false);
  };

  const updateVipMember = async (recordId, updateFields) => {
    if (updateFields.isDelete) setIsDeleting(true);
    if (updateFields.email !== undefined) {
      if (!newEmail || !newEmail.trim()) {
        toastify("Email can't be empty", "error");
        return;
      }
      if (!newEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        toastify("Please enter a valid email address", "error");
        return;
      }
    }

    const comunityLeaderUrl = `${document.location.origin.replace(
      document.location.pathname,
      ""
    )}/community/${user?.leaderCommunity?.name?.split(" ")?.join("")}`;

    const res = await api("post", "vipMember/updateVipMember", {
      comunityLeaderUrl,
      recordId,
      updateFields,
    });
    if(res.status){
      await getAllVipMembers();
      if(!updateFields.email){
        showNotificationToast(res.message);
      }
      // toastify(res.message);
      setNewEmail("");
    }else{
      toastify(res.message);
    }
    if (updateFields.isDelete) setIsDeleting(false);
    // toastify(`${res?.message}`, "success");
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeDropdownOnOutsideClick);

    return () => {
      document.removeEventListener("mousedown", closeDropdownOnOutsideClick);
    };
  }, []);

  useLayoutEffect(() => {
    if (!isOpen || !filterButtonRef.current || !filterMenuRef.current) return;

    const buttonRect = filterButtonRef.current.getBoundingClientRect();
    const menuHeight = filterMenuRef.current.offsetHeight;
    const spaceBelow = window.innerHeight - buttonRect.bottom;

    setFilterMenuFlipUp(spaceBelow < menuHeight && buttonRect.top > menuHeight);
  }, [isOpen]);

  useEffect(() => {
    if (!isNewVipAdded) getAllVipMembers();
    // Refresh VIP list when community switches (user payload updates).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewVipAdded, user, communityLeaderId]);

  const resendCodeAPi = async (email) => {
    try {
      const response = await api("post", "vipMember/resendVipCode", {
        email,
      });
      if(response.status){
        showNotificationToast("Code sent")
      }
    } catch (error) {
      toastify("code not sent some thing went wrong", "error");
    }
  };

  const showExpiryDate = (recordId, expiryDateValue) => {
    const selectedValidity = editValidity || expiryDateValue;
    return (
      <div ref={expiryDropdownRef} onMouseDown={(e) => e.nativeEvent.stopImmediatePropagation()}>
        {/* OLD: Bootstrap dropdown toggle — replaced with FloatingDropdownWithArrow
        <div className="dropdown mb-3 mb-lg-0">
          <button className={`btn btn-secondary dropdown-toggle memberDropDown selected`} onClick={() => setShowDropdown((prev) => !prev)}>
            {expiryDateValue}
            <img alt="" src={vipArrow} style={{ transform: showDropdown && "rotate(180deg)" }} />
          </button>
          <ul className="dropdown-menu show">
            <li><button className="dropdown-item" onClick={() => { setEditExpiryDateIndex(null); updateVipMember(recordId, { codeValidity: "Lifetime", endDate: null }); }}><span>Lifetime</span><span><img alt="" src={rightAngle} /></span></button></li>
            <li><button className="dropdown-item" onClick={() => { setShowDatePicker(true); }}><span>Specific end date</span><span><img alt="" src={rightAngle} /></span></button></li>
          </ul>
        </div>
        {showDatePicker && (
          <div className="mamberDateSelectBox allMemberDataPicker mb-3 mb-lg-0">
            <DatePicker autoFocus={true} className="form-control memberDropDown" minDate={tomorrow} onChange={(date) => { setEditExpiryDateIndex(null); setShowDatePicker(false); updateVipMember(recordId, { codeValidity: "Specific end date", endDate: date }); }} placeholderText="Select end date" />
          </div>
        )} */}

        {!showDatePicker && (
          <FloatingDropdownWithArrow
            label="Select access time"
            options={["Lifetime", "Specific end date"]}
            selectedValue={selectedValidity}
            setSelectedValue={(value) => {
              setEditValidity(value);
              if (value === "Lifetime") {
                setEditValidity("");
                setShowDatePicker(false);
                setEditExpiryDateIndex(null);
                updateVipMember(recordId, { codeValidity: "Lifetime", endDate: null });
              } else {
                setShowDatePicker(true);
              }
            }}
            focusedAllowed={false}
            noSelectedBg={true}
          />
        )}

        {showDatePicker && selectedValidity === "Specific end date" && (
          <div className="mt-2">
            <ExactDateSelector
              selectedDate={newEndDate}
              setSelectedDate={(date) => {
                if (!date) return;
                setNewEndDate(null);
                setEditValidity("");
                setEditExpiryDateIndex(null);
                setShowDatePicker(false);
                updateVipMember(recordId, {
                  codeValidity: "Specific end date",
                  endDate: date.toDate(),
                });
              }}
              minDate={dayjs().add(1, "day")}
              label="Select end date"
              autoOpen={true}
            />
          </div>
        )}
      </div>
    );
  };
  const openActionDropdown = (index, triggerEl, actions) => {
    const containerRect = allMemberBoxRef.current.getBoundingClientRect();
    const triggerRect = triggerEl.getBoundingClientRect();
    setDropdownPosition({
      top: triggerRect.bottom - containerRect.top,
      right: containerRect.right - triggerRect.right,
    });
    setDropdownActions(actions);
    setSelectedDropdownIndex(index);
  };

  return (
    <>
      <div className="allMemberBox" ref={allMemberBoxRef} style={{ position: "relative" }}>
        {isDeleting && (
          <div className="membersTableLoader">
            <div className="loading-4">
              <span className="span1"></span>
              <span className="span2"></span>
              <span className="span3"></span>
            </div>
          </div>
        )}
        <div className={`membersFiltersRow${isSearchExpanded ? " searchExpanded" : ""}`}>
          <div className="filterCol">
            <div className="memberFilteDropdown">
                <div className="dropdown" ref={filterDropdownRef}>
                  <button
                    className={`dropdown-btn${
                      isOpen || selectedOption !== "All subscribers"
                        ? " is-active"
                        : ""
                    }`}
                    onClick={() => setIsOpen(!isOpen)}
                    ref={filterButtonRef}
                  >
                    {allTradingCapitals.includes(selectedOption)
                      ? `Tier ${selectedOption === "UNLIMITED" || selectedOption === "VIP" ? selectedOption : `$${selectedOption}`}`
                      : selectedOption}{" "}
                    <img
                      alt=""
                      className={`arrow ${isOpen && "rotate"}`}
                      src={dropdownAngle}
                    />
                  </button>
                  {isOpen && (
                    <ul
                      className={`dropdown-menu${filterMenuFlipUp ? " dropup" : ""}`}
                      ref={filterMenuRef}
                    >
                      <li>
                        <button
                          onClick={() => {
                            handleOptionSelection("All subscribers");
                          }}
                        >
                          All subscribers
                          <img alt="Right Angle" src={rightAngle} />
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => {
                            handleOptionSelection("VIP members");
                          }}
                        >
                          VIP members <img alt="Right Angle" src={rightAngle} />
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => {
                            handleOptionSelection("VIP pending");
                          }}
                        >
                          VIP (pending){" "}
                          <img alt="Right Angle" src={rightAngle} />
                        </button>
                      </li>
                      {allTradingCapitals?.map((tradingCapital, index) => (
                        <li key={index}>
                          <button
                            onClick={() => {
                              handleOptionSelection(tradingCapital);
                            }}
                          >
                            Tier{" "}
                            {tradingCapital === "UNLIMITED" ||
                            tradingCapital === "VIP"
                              ? tradingCapital
                              : `$${tradingCapital}`}
                            <img alt="Right Angle" src={rightAngle} />
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
          </div>
          <div className="filterCol searchBar">
            <div className="memberSearchBox">
              <SearchBar
                value={searchQuery}
                searchValue={"Search email"}
                onFocus={() => setIsSearchExpanded(true)}
                onBlur={() => setIsSearchExpanded(false)}
                onChange={(e) => {
                  const query = e.target.value;
                  setSearchQuery(query);
                  setEditEmailIndex(null);
                  setSelectedDropdownIndex(null);

                  ["VIP members", "VIP pending", "VIP"].includes(selectedOption)
                    ? setFilteredVipMembers(
                        vipMembers.filter((member) =>
                          member?.email
                            ?.toLowerCase()
                            ?.includes(query.toLowerCase())
                        )
                      )
                    : setFilteredParticipants(
                        participants.filter((participant) =>
                          participant?.user?.email
                            ?.toLowerCase()
                            ?.includes(query.toLowerCase())
                        )
                      );
                }}
              />
            </div>
          </div>
          <div className="filterCol">
            <div className="memberMessageBox">
                <BubbleSvgButton
                  onClick={() => {
                    setIsSendMessages(true);
                    setSelectedUser(null);
                  }}
                  className={`${
                    isSendMessages
                      ? "active AllMemberMessageButton"
                      : "AllMemberMessageButton"
                  }`}
                  disabled={
                    participants?.length === 0 && vipMembers?.length === 0
                  }
                  text={"Message members"}
                  type="button"
                  variant="lightGray"
                  svgIcon={
                    <svg
                      height="12.941"
                      viewBox="1279.48 702.373 20.018 12.941"
                      width="20.018"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g data-name="noun-simple-message-icon-2920494">
                        <g data-name="Group 16342">
                          <path
                            d="M1298.013 702.373h-17.063c-.799 0-1.47.655-1.47 1.47v10c0 .8.655 1.47 1.47 1.47h17.079c.799 0 1.47-.654 1.47-1.47v-10a1.49 1.49 0 0 0-1.486-1.47Zm.112 11.47a.11.11 0 0 1-.112.113h-17.063a.11.11 0 0 1-.112-.112v-10.001a.11.11 0 0 1 .112-.112h17.079a.11.11 0 0 1 .112.112v10Z"
                            data-name="Path 10849"
                            fillRule="evenodd"
                            fill={`${isSendMessages ? "white" : "#9a9b9b"}`}
                          />
                          <path
                            d="M1281.813 704.658v.926l7.38 4.186.289.16 7.668-4.346v-.926l-7.668 3.914-7.669-3.914Z"
                            data-name="Path 10850"
                            fillRule="evenodd"
                            fill={`${isSendMessages ? "white" : "#9a9b9b"}`}
                          />
                        </g>
                      </g>
                    </svg>
                  }
                  svgPosition="right"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                  mainDivStyle={{
                    width: "100%",
                    height: "55px",
                  }}
                />
            </div>
          </div>
        </div>
        <div className="overflow-x-auto">
          <Table className="membersTable">
            <thead>
              <tr>
                {["VIP members", "VIP pending", "VIP"].includes(
                  selectedOption
                ) ? (
                  <>
                    <th className="email-th" style={{ width: "35%" }}>
                      Email
                    </th>
                    <th className="exp-th" style={{ width: "25%" }}>
                      Expiry Date
                    </th>
                    <th className="code-th" style={{ width: "15%" }}>
                      VIP code
                    </th>
                    <th className="status-th" style={{ width: "15%" }}>
                      Status
                    </th>
                    <th className="action-th" style={{ width: "10%" }}></th>
                  </>
                ) : (
                  <>
                    <th className="email-th" style={{ width: "25%" }}>
                      Email
                    </th>
                    <th className="exp-th" style={{ width: "20%" }}>
                      Portfolio
                    </th>
                    <th className="code-th" style={{ width: "25%" }}>
                      Joined
                    </th>
                    <th className="status-th" style={{ width: "10%" }}>
                      Tier
                    </th>
                    <th className="status-th" style={{ width: "10%" }}>
                      Status
                    </th>
                    <th className="action-th" style={{ width: "10%" }}></th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {["VIP members", "VIP pending", "VIP"].includes(
                selectedOption
              ) ? (
                filteredVipMembers.length > 0 ? (
                  filteredVipMembers
                    .slice((page - 1) * 10, page * 10)
                    .map((member, index) => (
                      <tr key={index}>
                        <td className="emailTD">
                          <div className="forDesktop">
                            {editEmailIndex === index ? (
                              <>
                                <Form onSubmit={(e) => e.preventDefault()}>
                                  <Form.Group className="mb-2 mb-lg-0">
                                    <Form.Control
                                      autoFocus
                                      onChange={(e) =>
                                        setNewEmail(e.target.value)
                                      }
                                      placeholder="VIP member email"
                                      type="email"
                                      value={newEmail}
                                    />
                                  </Form.Group>
                                </Form>
                              </>
                            ) : (
                              member?.email
                            )}
                          </div>
                          <div className="forMobile">
                            <div className="editEmailBox">
                              <p className="title">Email</p>
                              {editEmailIndex === index ? (
                                <div className="mb-3">
                                  <Form onSubmit={(e) => e.preventDefault()}>
                                    <Form.Group className="mb-2 mb-lg-0">
                                      <Form.Control
                                        autoFocus
                                        onChange={(e) =>
                                          setNewEmail(e.target.value)
                                        }
                                        placeholder="VIP member email"
                                        type="email"
                                        value={newEmail}
                                      />
                                    </Form.Group>
                                    <div className="mt-2 d-flex d-lg-none d-md-none">
                                      <button
                                        className="UpdateButton"
                                        onClick={() => {
                                          setEditEmailIndex(null);
                                          updateVipMember(member._id, {
                                            email: newEmail,
                                            currentEmail:member.email
                                          });
                                        }}
                                        size="sm"
                                        type="button"
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="ms-2 CancelButton"
                                        onClick={() =>
                                          setEditEmailIndex(null)
                                        }
                                        size="sm"
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </Form>
                                </div>
                              ) : (
                                <p className="des">{member?.email}</p>
                              )}
                            </div>
                            <div className="combieneBox">
                              <div className="combieneBox__stats">
                                <div className="item">
                                  <p className="title">Expiry Date</p>
                                  <p className="des">
                                    {editExpiryDateIndex === index && isMobile
                                      ? showExpiryDate(
                                          member?._id,
                                          member?.codeValidity
                                        )
                                      : member?.codeValidity === "Lifetime"
                                      ? member?.codeValidity
                                      : getEndDate(member?.endDate)}
                                  </p>
                                </div>
                                <div className="item">
                                  <p className="title">VIP code</p>
                                  <p className="des">
                                    {member?.vipCode}
                                    <button
                                      className="copyBtn"
                                      onClick={() => {
                                        navigator.clipboard
                                          .writeText(member?.vipCode)
                                          .then(() => {
                                            toastify(
                                              "Vip code copied to clipboard!",
                                              "success"
                                            );
                                          });
                                      }}
                                      type="button"
                                    >
                                      <img alt="" src={NewCopyIcon} />
                                    </button>
                                  </p>
                                </div>
                                <div className="item">
                                  <p className="title">Status</p>
                                  <p className="des">
                                    {member?.codeValidity ===
                                      "Specific end date" &&
                                    new Date(member?.endDate) < new Date() ? (
                                      <img alt="Expired" src={cancel} />
                                    ) : member?.isUsed ? (
                                      <img alt="Used" src={vipCheckMark} />
                                    ) : (
                                      "Pending"
                                    )}
                                  </p>
                                </div>
                              </div>
                              {editEmailIndex !== index && (
                                <div className="combieneBox__action">
                                  <button
                                    type="button"
                                    aria-label="Member actions"
                                    onClick={(e) => {
                                      setEditExpiryDateIndex(null);
                                      if (selectedDropdownIndex === index) {
                                        setSelectedDropdownIndex(null);
                                        return;
                                      }
                                      openActionDropdown(index, e.currentTarget, [
                                        {
                                          label: "Edit email",
                                          onClick: () => {
                                            setEditEmailIndex(index);
                                            setNewEmail(member?.email);
                                            setSelectedDropdownIndex(null);
                                          },
                                        },
                                        {
                                          label: "Change date",
                                          onClick: () => {
                                            setEditExpiryDateIndex(index);
                                            setEditValidity("");
                                            setShowDatePicker(false);
                                            setNewEndDate(null);
                                            setSelectedDropdownIndex(null);
                                          },
                                        },
                                        {
                                          label: "Send code again",
                                          onClick: () => {
                                            resendCodeAPi(member?.email);
                                            setSelectedDropdownIndex(null);
                                          },
                                        },
                                        {
                                          label: "Send message",
                                          onClick: () => {
                                            setIsSendMessages(true);
                                            setSelectedDropdownIndex(null);
                                            setSelectedUser(member);
                                          },
                                        },
                                        {
                                          label: "Delete member",
                                          onClick: () => {
                                            setSelectedDropdownIndex(null);
                                            setShowDeleteModel({
                                              apiObj: { memberId: member?._id },
                                              show: true,
                                            });
                                          },
                                        },
                                      ]);
                                    }}
                                  >
                                    <img alt="" src={tierAction} />
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="exp-td">
                          {editExpiryDateIndex === index && !isMobile
                            ? showExpiryDate(
                                member?._id,
                                member?.codeValidity
                              )
                            : member?.codeValidity === "Lifetime"
                            ? member?.codeValidity
                            : getEndDate(member?.endDate)}
                        </td>
                        <td className="code-td">
                          <div className="d-flex">
                            {member?.vipCode}
                            <button
                              className="copyBtn"
                              onClick={() => {
                                navigator.clipboard
                                  .writeText(member?.vipCode)
                                  .then(() => {
                                    toastify(
                                      "Vip code copied to clipboard!",
                                      "success"
                                    );
                                  });
                              }}
                              type="button"
                            >
                              <img alt="" src={NewCopyIcon} />
                            </button>
                          </div>
                        </td>
                        <td className="status-td">
                          <div className="statusInnerBox">
                            {editEmailIndex === index ? (
                              <div
                                style={{
                                  alignItems: "center",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <button
                                  className="desktopSave btn d-none d-lg-block d-md-block"
                                  onClick={() => {
                                    setEditEmailIndex(null);
                                    updateVipMember(member._id, {
                                      email: newEmail,
                                      currentEmail:member.email
                                    });
                                  }}
                                >
                                  Save
                                </button>
                              </div>
                            ) : member?.codeValidity ===
                                "Specific end date" &&
                              new Date(member?.endDate) < new Date() ? (
                              <img alt="Expired" src={cancel} />
                            ) : member?.isUsed ? (
                              <img alt="Used" src={vipCheckMark} />
                            ) : (
                              "Pending"
                            )}
                          </div>
                        </td>
                        <td
                          className="actionDropdown text-end"
                        >
                          <div className="actionInnerBox">
                            {editEmailIndex === index ? (
                              <div
                                style={{
                                  alignItems: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  className="desktopCancle ms-2 d-none d-lg-block d-md-block"
                                  onClick={() => {
                                    setEditEmailIndex(null);
                                  }}
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <button
                                className=""
                                onClick={() => {
                                  setEditExpiryDateIndex(null);
                                  if (selectedDropdownIndex === index) { setSelectedDropdownIndex(null); return; }
                                  const triggerEl = actionButtonTriggerRefs.current.get(index);
                                  if (!triggerEl) return;
                                  openActionDropdown(index, triggerEl, [
                                    { label: "Edit email", onClick: () => { setEditEmailIndex(index); setNewEmail(member?.email); setSelectedDropdownIndex(null); } },
                                    { label: "Change date", onClick: () => { setEditExpiryDateIndex(index); setEditValidity(""); setShowDatePicker(false); setNewEndDate(null); setSelectedDropdownIndex(null); } },
                                    { label: "Send code again", onClick: () => { resendCodeAPi(member?.email); setSelectedDropdownIndex(null); } },
                                    { label: "Send message", onClick: () => { setIsSendMessages(true); setSelectedDropdownIndex(null); setSelectedUser(member); } },
                                    { label: "Delete member", onClick: () => { setSelectedDropdownIndex(null); setShowDeleteModel({ apiObj: { memberId: member?._id }, show: true }); } },
                                  ]);
                                }}
                                ref={(el) => {
                                  if (el) actionButtonTriggerRefs.current.set(index, el);
                                  else actionButtonTriggerRefs.current.delete(index);
                                }}
                              >
                                <img alt="" src={tierAction} />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td className="text-center" colSpan="5">
                      {searchQuery.trim()
                        ? `No results found for "${searchQuery}"`
                        : "No member Found"}
                    </td>
                  </tr>
                )
              ) : filteredParticipants.length > 0 ? (
                filteredParticipants
                  .slice((page - 1) * 10, page * 10)
                  .map((participant, index) => (
                    <tr key={index}>
                      <td className="emailTD">
                        <div className="forDesktop">
                          {editEmailIndex === index ? (
                            <>
                              <Form onSubmit={(e) => e.preventDefault()}>
                                <Form.Group className="mb-2 mb-lg-0">
                                  <Form.Control
                                    autoFocus
                                    onChange={(e) =>
                                      setNewEmail(e.target.value)
                                    }
                                    placeholder="VIP member email"
                                    type="email"
                                    value={newEmail}
                                  />
                                </Form.Group>
                              </Form>
                            </>
                          ) : (
                            participant?.user?.email
                          )}
                        </div>
                        <div className="forMobile">
                          <div className="editEmailBox">
                            <p className="title">Email</p>
                            {editEmailIndex === index ? (
                              <div className="mb-3">
                                <Form onSubmit={(e) => e.preventDefault()}>
                                  <Form.Group className="mb-2 mb-lg-0">
                                    <Form.Control
                                      autoFocus
                                      onChange={(e) =>
                                        setNewEmail(e.target.value)
                                      }
                                      placeholder="VIP member email"
                                      type="email"
                                      value={newEmail}
                                    />
                                  </Form.Group>
                                  <div className="mt-2 d-flex d-lg-none d-md-none">
                                    <button
                                      className="UpdateButton"
                                      onClick={() => {
                                        setEditEmailIndex(null);
                                      }}
                                      size="sm"
                                      type="button"
                                    >
                                      Save
                                    </button>
                                    <button
                                      className="ms-2 CancelButton"
                                      onClick={() => setEditEmailIndex(null)}
                                      size="sm"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </Form>
                              </div>
                            ) : (
                              <p className="des">
                                {participant?.user?.email}
                              </p>
                            )}
                          </div>
                          <div className="combieneBox">
                            <div className="combieneBox__stats">
                              <div className="item">
                                <p className="title">Portfolio</p>
                                <p className="des">
                                  $
                                  {simplifyTradingVolume(
                                    participant.balance
                                  )}
                                </p>
                              </div>
                              <div className="item">
                                <p className="title">Joined</p>
                                <p className="des">
                                  {dayjs(participant?.date).format("DD-MM-YYYY")}
                                </p>
                              </div>
                              <div className="item">
                                <p className="title">Tier</p>
                                <p className="des">
                                  {getTradingCapital(participant)}
                                </p>
                              </div>
                              <div className="item">
                                <p className="title">Status</p>
                                {(() => {
                                  const memberStatus =
                                    getEffectiveMemberStatus(participant);
                                  const isInactive =
                                    memberStatus === "inactive";
                                  return (
                                    <p
                                      className={`des ${
                                        isInactive
                                          ? "is-status-inactive"
                                          : "is-status-active"
                                      }`}
                                    >
                                      {isInactive ? "Inactive" : "Active"}
                                    </p>
                                  );
                                })()}
                              </div>
                            </div>
                            {editEmailIndex !== index && (
                              <div className="combieneBox__action">
                                <button
                                  type="button"
                                  aria-label="Member actions"
                                  onClick={(e) => {
                                    if (selectedDropdownIndex === index) {
                                      setSelectedDropdownIndex(null);
                                      return;
                                    }
                                    openActionDropdown(
                                      index,
                                      e.currentTarget,
                                      [
                                        {
                                          label: "Send message",
                                          onClick: () => {
                                            setIsSendMessages(true);
                                            setSelectedDropdownIndex(null);
                                            setSelectedUser(participant.user);
                                          },
                                        },
                                        {
                                          label:
                                            getEffectiveMemberStatus(
                                              participant
                                            ) === "inactive"
                                              ? "Activate member"
                                              : "Deactivate member",
                                          onClick: () => {
                                            setSelectedDropdownIndex(null);
                                            setShowStatusConfirmModal({
                                              participant,
                                              show: true,
                                            });
                                          },
                                        },
                                        {
                                          label: "Delete member",
                                          onClick: () => {
                                            const _foundCommunity =
                                              participant.user.memberCommunities?.find(
                                                (community) =>
                                                  community.community ===
                                                  communityLeaderId
                                              );
                                            setSelectedDropdownIndex(null);
                                            setSelectedParticipant(
                                              participant.user._id
                                            );
                                            setSelectedSubscription(
                                              _foundCommunity?.sessionId
                                            );
                                            setShowDeleteModel({
                                              apiObj: {},
                                              show: true,
                                            });
                                          },
                                        },
                                      ]
                                    );
                                  }}
                                >
                                  <img alt="" src={tierAction} />
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="exp-td">
                        $
                        {simplifyTradingVolume(
                          participant?.balance
                        )}
                      </td>
                      <td className="code-td">
                        {dayjs(participant?.date).format("DD-MM-YYYY")}
                      </td>
                      <td className="status-td">
                        <div className="statusInnerBox">
                          {editEmailIndex === index ? (
                            <div
                              style={{
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <button
                                className="desktopSave btn d-none d-lg-block d-md-block"
                                onClick={() => {
                                  setEditEmailIndex(null);
                                }}
                              >
                                Save
                              </button>
                            </div>
                          ) : (
                            getMemberTierDisplay(participant)
                          )}
                        </div>
                      </td>
                      <td className="member-status-td">
                        {(() => {
                          const memberStatus = getEffectiveMemberStatus(participant);
                          const isInactive = memberStatus === "inactive";
                          return (
                            <span className={`memberStatusBadge ${isInactive ? "memberStatusInactive" : "memberStatusActive"}`}>
                              {isInactive ? "Inactive" : "Active"}
                            </span>
                          );
                        })()}
                      </td>
                      <td
                        className="actionDropdown text-end"
                      >
                        <div className="actionInnerBox">
                          {editEmailIndex === index ? (
                            <div
                              style={{
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                className="desktopCancle ms-2 d-none d-lg-block d-md-block"
                                onClick={() => {
                                  setEditEmailIndex(null);
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <button
                              className=""
                              onClick={() => {
                                if (selectedDropdownIndex === index) { setSelectedDropdownIndex(null); return; }
                                const triggerEl = actionButtonTriggerRefs.current.get(index);
                                if (!triggerEl) return;
                                openActionDropdown(index, triggerEl, [
                                  { label: "Send message", onClick: () => { setIsSendMessages(true); setSelectedDropdownIndex(null); setSelectedUser(participant.user); } },
                                  {
                                    label: getEffectiveMemberStatus(participant) === "inactive" ? "Activate member" : "Deactivate member",
                                    onClick: () => { setSelectedDropdownIndex(null); setShowStatusConfirmModal({ participant, show: true }); },
                                  },
                                  {
                                    label: "Delete member",
                                    onClick: () => {
                                      const _foundCommunity = participant.user.memberCommunities?.find((community) => community.community === communityLeaderId);
                                      setSelectedDropdownIndex(null);
                                      setSelectedParticipant(participant.user._id);
                                      setSelectedSubscription(_foundCommunity?.sessionId);
                                      setShowDeleteModel({ apiObj: {}, show: true });
                                    },
                                  },
                                ]);
                              }}
                              ref={(el) => {
                                if (el) actionButtonTriggerRefs.current.set(index, el);
                                else actionButtonTriggerRefs.current.delete(index);
                              }}
                            >
                              <img alt="" src={tierAction} />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td className="text-center" colSpan="5">
                    {searchQuery.trim()
                      ? `No results found for "${searchQuery}"`
                      : "No member Found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="paginationWrapper">
          {totalPages > 0 && (
            <TablePagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          )}
        </div>
        {selectedDropdownIndex !== null && dropdownActions.length > 0 && (
          <div
            className="actionDropdownMenu updateDropdown"
            style={{
              position: "absolute",
              top: `${dropdownPosition.top}px`,
              right: `${dropdownPosition.right}px`,
            }}
            ref={sharedDropdownRef}
          >
            {dropdownActions.map((action, i) => (
              <button key={i} className="dropdown-item" onClick={action.onClick}>
                {action.label}
              </button>
            ))}
          </div>
        )}
        <ConfirmModal
          show={showDeleteModel.show}
          onHide={() => setShowDeleteModel({ apiObj: {}, show: false })}
          title="Do you want to delete member?"
          description="Member will be deleted. You can add member any time."
          confirmText="Ok, delete"
          onConfirm={() => {
            ["VIP members", "VIP pending", "VIP"].includes(selectedOption)
              ? updateVipMember(showDeleteModel.apiObj?.memberId, { isDelete: true })
              : unsubscribeMember();
            setShowDeleteModel({ show: false, apiObj: {} });
          }}
        />
        <ConfirmModal
          show={showStatusConfirmModal.show}
          onHide={() => setShowStatusConfirmModal({ participant: null, show: false })}
          title={
            showStatusConfirmModal.participant &&
            getEffectiveMemberStatus(showStatusConfirmModal.participant) === "inactive"
              ? "Do you want to activate this member?"
              : "Do you want to deactivate this member?"
          }
          description={
            showStatusConfirmModal.participant &&
            getEffectiveMemberStatus(showStatusConfirmModal.participant) === "inactive"
              ? "Member will be activated and can access the community."
              : "Member will be deactivated. You can reactivate them any time."
          }
          confirmText={
            showStatusConfirmModal.participant &&
            getEffectiveMemberStatus(showStatusConfirmModal.participant) === "inactive"
              ? "Ok, activate"
              : "Ok, deactivate"
          }
          onConfirm={() => {
            updateMemberStatus(showStatusConfirmModal.participant);
            setShowStatusConfirmModal({ participant: null, show: false });
          }}
        />
      </div>

      {isSendMessages && (
        <MessageModal
          handleClose={() => {
            setIsSendMessages(false);
          }}
          selectedUser={selectedUser}
          show={isSendMessages}
        />
      )}
    </>
  );
};

export default AllMembers;
